import { BCE_SEED_V3 } from '@docgen/seed-bce';
import type { DocumentV3 } from '@docgen/schema';

/**
 * A fresh proposal document from the BCE template, with its own id and name.
 * Shared by the standalone Proposals page and the Salesforce embed's proposal
 * tab so both start from the same template.
 *
 * @param name - The proposal name.
 * @returns A new DocumentV3.
 */
export function newProposalDocument(name: string): DocumentV3 {
  const doc = structuredClone(BCE_SEED_V3) as DocumentV3;
  return { ...doc, id: `prop-${Date.now()}`, name };
}
